import { FC } from 'react';

export const StarSolid: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.171 3.24452C10.8171 1.58573 13.1813 1.585 13.8285 3.2433L15.497 7.51873L20.143 7.76708C21.907 7.86138 22.6898 10.084 21.2712 11.2236L17.6664 14.1194L18.8611 18.5466C19.3371 20.3104 17.3742 21.6249 15.9058 20.6871L11.9993 18.1919L8.09896 20.6853C6.63068 21.6239 4.66699 20.3094 5.14304 18.5453L6.33725 14.1198L2.72945 11.2242C1.30991 10.0849 2.0926 7.86133 3.85702 7.76708L8.50627 7.51873L10.171 3.24452Z"
			fill="currentColor"
		/>
	</svg>
);
